import { TROPHIES } from '@gramas/shared'
import { List, ListRow, SectionLabel } from '@gramas/ui'
import { useLiveQuery } from 'dexie-react-hooks'
import { useState } from 'react'
import { listAwards } from '../db/repo.js'

export function TrophyCabinet() {
  /** Which earned trophy is showing what she said when it fired. */
  const [openTrophy, setOpenTrophy] = useState<string | null>(null)

  const awards = useLiveQuery(() => listAwards(), [], [])
  const earned = new Set(awards.map((a) => a.awardKey))

  return (
    <>
      {/* Always rendered, even on a fresh account: an empty cabinet says
          nothing, whereas ten locked doors say there is something to find.
          The locked rows keep their titles hidden — every trophy is meant to
          land as a surprise, and a list of names spends all ten jokes at once. */}
      <SectionLabel>
        Trofėjų spinta · {earned.size} iš {TROPHIES.length}
      </SectionLabel>
      <List className="border-y border-line bg-surface">
        {TROPHIES.map((def, i) => {
          const award = awards.find((a) => a.awardKey === def.key)
          const open = openTrophy === def.key
          return (
            <div key={def.key}>
              <ListRow
                last={i === TROPHIES.length - 1 && !open}
                title={award ? def.title : '???'}
                subtitle={award ? def.description : 'Dar neatrakinta'}
                value={award?.awardedOn}
                className={award ? undefined : 'opacity-45'}
                // Only earned rows open. A locked one has nothing to say, and
                // making it tappable would imply it does.
                onActivate={award ? () => setOpenTrophy(open ? null : def.key) : undefined}
              />
              {/* What she said the moment it fired. Written once per trophy,
                  shown once when it fired, and until now stored nowhere a
                  person could ever go back and read it — the cabinet showed
                  the catalogue's own flat description instead. */}
              {open && (
                <p className="border-line border-b bg-raised px-4 py-3 text-balance text-dim text-sm">
                  {def.line}
                </p>
              )}
            </div>
          )
        })}
      </List>
    </>
  )
}
